export type ServerSide = boolean;

export const SET_SERVER_SIDE = 'SET_SERVER_SIDE';

export interface SetServerSideAction {
	type: typeof SET_SERVER_SIDE;
	payload: ServerSide;
}
